/* Native Shopify signup. A discount is revealed only after server confirmation. */
(() => {
  'use strict';
  const root = document.querySelector('[data-npop-root]');
  const dialog = root?.querySelector('[data-npop-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const invite = root.querySelector('[data-npop-invite]');
  const state = root.querySelector('[data-npop-state]').dataset.npopState;
  const delay = Math.max(12, Number(root.dataset.npopDelay) || 12) * 1000;
  const days = Math.max(1, Number(root.dataset.npopDismissDays) || 7);
  const get = key => { try { return Number(localStorage.getItem(key)) || 0; } catch { return 0; } };
  const save = key => { try { localStorage.setItem(key, String(Date.now())); } catch {} };
  const recent = (key, count) => Date.now() - get(key) < count * 86400000;
  const suppressed = recent('am-popup-success', 180) || recent('am-popup-dismissed', days);
  const mobile = matchMedia('(max-width: 760px)');
  let autoShown = false, ready = false, previousOverflow = '', previousFocus;
  root.hidden = false;
  document.querySelectorAll('[data-npop-open]').forEach(button => { button.hidden = false; });
  function open() {
    if (dialog.open) return;
    // Never stack offers on top of a cart, size guide or other modal.
    if (document.querySelector('dialog[open], .drawer.is-open')) return;
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    invite.hidden = true;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    autoShown = true;
  }
  function close(dismiss = true) {
    autoShown = true;
    if (dismiss) save('am-popup-dismissed');
    invite.hidden = true;
    if (dialog.open) dialog.close();
  }
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    previousFocus?.focus({preventScroll: true});
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-npop-open]')) open();
    if (event.target.closest('[data-npop-close], [data-npop-dismiss]')) close();
  });
  function eligible(exit = false) {
    if (!ready || suppressed || autoShown || document.hidden) return;
    if (document.activeElement?.closest('form')) return;
    if (mobile.matches) { invite.hidden = false; return; }
    // Wait for browsing engagement; no immediate landing-page takeover.
    if (exit || scrollY > 200) open();
  }
  if (state === 'success') { save('am-popup-success'); open(); }
  else if (state === 'error') open();
  else if (!suppressed) {
    setTimeout(() => { ready = true; eligible(); }, delay);
    addEventListener('scroll', () => eligible(), {passive: true});
    document.addEventListener('mouseout', event => {
      if (!mobile.matches && !event.relatedTarget && event.clientY <= 8) eligible(true);
    });
  }
  root.querySelector('form').addEventListener('submit', event => {
    if (!event.target.checkValidity()) return;
    event.target.setAttribute('aria-busy', 'true');
    // Shopify injects its CAPTCHA outside the dialog's top layer.
    // Close the dialog so the native verification remains visible and operable.
    close(false);
    root.querySelector('[data-npop-progress]').hidden = false;
  });
  addEventListener('pageshow', () => {
    root.querySelector('form').removeAttribute('aria-busy');
    root.querySelector('[data-npop-progress]').hidden = true;
  });
  root.querySelector('[data-npop-copy]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const code = root.querySelector('[data-npop-code]');
    const status = root.querySelector('[data-npop-copy-status]');
    try {
      await navigator.clipboard.writeText(code.textContent.trim());
      status.textContent = button.dataset.copied;
    } catch {
      const range = document.createRange(); range.selectNodeContents(code);
      const selection = getSelection(); selection.removeAllRanges(); selection.addRange(range);
      status.textContent = button.dataset.copyError;
    }
  });
})();
